import {
  ProductItem, 
  Products,
  CartDetails,
  CartsPage,
  Login, 
} from '../pages'
export default [
  {
    label: 'login',
    path: '/login',
    component: Login
  },
  {
    label: 'productitem',
    path: '/productitem',
    component: ProductItem
  },
  {
    label: 'products',
    path: '/products',
    component: Products
  },
  {
    label: 'cartspage',
    path: '/cartspage',
    component: CartsPage
  },
  {
    label: 'cartdetail',
    path: '/cartdetails',
    component: CartDetails
  }
]